// generated by genversion
export var version = '3.4.2';
//# sourceMappingURL=version.js.map